
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"32","height":"24","version":"1.1","id":"Layer_1","xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink","x":"0px","y":"0px","viewBox":"0 0 122.88 85.629","enable-background":"new 0 0 122.88 85.629","xml:space":"preserve"}, attrs),
              ...rest,
            },
            children.concat([_c('g',[_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","fill":"#FFFFFF","d":"M6.966,0.239h108.948c3.7,0,6.728,3.027,6.728,6.727v71.696 c0,3.7-3.027,6.728-6.728,6.728H6.966c-3.699,0-6.727-3.027-6.727-6.728V6.966C0.239,3.266,3.267,0.239,6.966,0.239L6.966,0.239z"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M6.966,0.239h108.948c3.7,0,6.728,3.027,6.728,6.727v50.307H0.239V6.966 C0.239,3.266,3.267,0.239,6.966,0.239L6.966,0.239z"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","fill":"#0072CE","d":"M6.966,0.239h108.948c3.7,0,6.728,3.027,6.728,6.727v21.39H0.239 V6.966C0.239,3.266,3.267,0.239,6.966,0.239L6.966,0.239z"}}),_c('path',{attrs:{"fill":"#CCCCCC","d":"M6.966,0h108.948c1.915,0,3.656,0.784,4.919,2.046c1.264,1.264,2.047,3.005,2.047,4.92v71.696 c0,1.915-0.783,3.657-2.046,4.92c-1.264,1.263-3.005,2.047-4.92,2.047H6.966c-1.914,0-3.656-0.784-4.919-2.047 C0.784,82.32,0,80.578,0,78.662V6.966c0-1.916,0.784-3.658,2.046-4.92C3.31,0.784,5.052,0,6.966,0L6.966,0z M115.914,0.479H6.966 c-1.784,0-3.406,0.729-4.581,1.905C1.209,3.56,0.479,5.183,0.479,6.966v71.696c0,1.784,0.73,3.406,1.906,4.582 c1.175,1.177,2.797,1.906,4.581,1.906h108.948c1.784,0,3.406-0.73,4.582-1.905c1.176-1.176,1.906-2.799,1.906-4.583V6.966 c0-1.784-0.73-3.407-1.906-4.583S117.698,0.479,115.914,0.479L115.914,0.479z"}})])])
          )
        }
      }
    